<template>
    <div class="container">
        <router-link to="/promo/bonuses/add">
            <v-btn color="primary">Add New Bonus</v-btn>
        </router-link>
      <div class="mt-5">
        <bonus-table :data="tableData" />
      </div>
    </div>
</template>
  
<script>
import BonusTable from '../components/bonus-table.vue';
import { PromoService } from "@/services";

export default {
    components: {
        BonusTable,
    },
    data() {
        return {
            tableData: [
               
            ],
        };
    },
    async mounted() {
    this.retieveBonus();
  //  this.loadCryptoTraders(this.cryptoFilter)
  },
    methods : {
        async retieveBonus(){
            const data = await PromoService.retrieveAllBonuses();
            console.log('data', data);
            this.tableData=data;
        }
    }
};
</script>
  